export const ActionTypes = {
    APP_ID: "APP_ID",
    OKTAAPPID: "OKTA_ID",
    EMAILLOGO: "EMAIL_LOGO",
    HAM_ICON:"HAM_ICON",
    USER_DETAIL: "USER_DETAIL",
    IDX_NOTIFICATION: "IDX_NOTIFICATION",
    QUICK_LINK_SELECTED_INDEX: "QUICK_LINK_SELECTED_INDEX",
    SELCTED_QUICK_LINK: "SELCTED_QUICK_LINK"
}